module.exports = __webpack_public_path__ + "img/T7A6702.926d1a4b.jpg";